import { styled, alpha } from "@mui/material/styles";
import { Button, DialogContent, IconButton } from "@mui/material";

export const AddEditButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "effect",
})<{ effect: "add" | "edit" }>(
  ({ theme }) => ({
    minWidth: "unset",
    // width:"20px",
    // height:"20px",
    // borderRadius:"6px",
    fontSize: theme.typography.body2.fontSize,
    padding: 0,
    textTransform: "none",
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.primary.main,
    boxShadow: theme.shadows[3],
  }),
  ({ effect, theme }) => ({
    ...(effect === "add" && {
      // borderColor: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      "&:hover": {
        borderColor: alpha(theme.palette.primary.contrastText, 0.5),
      },
    }),
  })
);

export const Content = styled(DialogContent, {
  shouldForwardProp: (prop) => prop !== "verticalOrientation",
})<{ verticalOrientation: boolean }>(
  {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",

    "& > .MuiAutocomplete-root, & > .MuiFormControl-root": {
      width: "45%",
      margin: "10px 0",
    },

    "& > .MuiFormControlLabel-root": {
      width: "45%",
    },
  },
  ({ verticalOrientation }) => ({
    ...(verticalOrientation && {
      flexFlow: "column",

      "& > .MuiAutocomplete-root,  & > .MuiFormControl-root, & > .MuiFormControlLabel-root": {
        width: "70%",
      },
    }),
  })
);
